<template>
  <validation-observer
    vid="stepIntroForm"
    ref="stepIntroForm"
    tag="div"
    novalidate
  >
    <vvs-control-wrapper label="4. Firma Bilgileri"></vvs-control-wrapper>

    <vvs-input
      name="Ticaret Ünvanı"
      label="Ticaret Ünvanı"
      placeholder="Şahıs şirketleri Adı Soyadı'yı giriniz"
      validate="required|withoutEmoji|max:255"
      maxlength="255"
      v-model="step.taxInfo.officialName"
      normal-label
    ></vvs-input>

    <vvs-input
      name="Vergi Kimlik No."
      label="Vergi Kimlik No."
      placeholder="Şahıs şirketleri TCKN'yi giriniz"
      validate="required|numeric|min:10|max:11|tinOrTcNumber"
      maxlength="11"
      v-model="step.taxInfo.tin"
      normal-label
    ></vvs-input>

    <vvs-input
      name="3. Vergi Dairesi"
      label="Vergi Dairesi"
      placeholder="Vergi lehvasında bulunan Vergi Dairesi'ni giriniz"
      validate="required|withoutEmoji|min:2|max:100"
      maxlength="100"
      v-model="step.taxInfo.taxOffice"
      normal-label
    ></vvs-input>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepCompanyInformation',
  mixins: [stepsMixin],
};
</script>
